<template>
  <div class="input-files">
    <h3 class="input-files__label fw-normal mb-10">{{ labelText }}</h3>

    <p class="mb-10 text-grey">
      Всего файлов: {{ countFiles }}
    </p>

    <div v-if="isEdit" :class="{ 'mb-16': modelValue }">
      <input
        ref="inputFiles"
        type="file"
        :name="name"
        :accept="acceptAttr"
        hidden
        :multiple="multiple"
        @change="uploadFilesHandler"
      />

      <VButton
        text="Выберите файл"
        size="xxl"
        @click.native="$refs.inputFiles.click()"
      />

      <small class="text-grey">
        {{ hintText }}
      </small>
    </div>

    <AttachmentFilesList
      v-if="modelValue"
      class="input-files__list"
      :files="modelValue"
      :is-enabled-remove-file="isEdit"
      :is-enabled-download-file="isEnabledDownloadFile"
      :with-preview="withPreview"
      @onRemoveFile="removeFileHandler"
    />
  </div>
</template>

<script>
import AttachmentFilesList from '@/components/files/AttachmentFiles/AttachmentFilesList'
import VButton from '@/components/simple/button/VButton'
import { mixinInputFiles } from '@/mixins/form/mixinInputFiles'

export default {
  name: 'VInputFiles',
  components: {
    AttachmentFilesList,
    VButton
  },
  mixins: [mixinInputFiles],
  props: {
    withPreview: {
      type: Boolean,
      required: false,
      default: false
    },
    // Массив допустимых типов: расширения ('.png', '.pdf') и/или MIME ('image/png', 'image/*')
    accept: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelText () {
      return this.label || (this.isEdit ? 'Прикрепите файлы' : 'Файлы')
    },
    acceptAttr () {
      return this.accept.join(',')
    },
    hintText () {
      if (this.accept.length) {
        return `Формат файла: ${this.accept.join(', ')}`
      }
      return 'Формат файла: pdf, jpeg, png, webp, gif, csv, plain, MSWord'
    }
  },

  methods: {
    // Переопределяем метод из миксина, чтобы отфильтровать файлы до обработки
    uploadFilesHandler (event) {
      const input = event?.target || this.$refs.inputFiles
      let files = Array.from(input?.files || [])

      if (this.accept.length) {
        files = files.filter(f => this.isFileAccepted(f))
      }

      if (files.length) this.addFiles(files)

      if (input) input.value = ''
    },

    addFiles (files) {
      const arr = Array.from(files || [])
      if (!arr.length) return

      if (!this.multiple) {
        this.modelValue = [arr[0]]
        return
      }

      if (this.countFiles) {
        return this.modelValue.push(...arr)
      }
      this.modelValue = [...arr]
    },

    isFileAccepted (file) {
      const fileName = (file.name || '').toLowerCase()
      const fileType = (file.type || '').toLowerCase()

      return this.accept.some(raw => {
        const pattern = String(raw).toLowerCase()

        // расширение: ".png"
        if (pattern.startsWith('.')) {
          return fileName.endsWith(pattern)
        }
        // wildcard mime: "image/*"
        if (pattern.endsWith('/*')) {
          return fileType.startsWith(pattern.slice(0, -1))
        }
        // точный mime: "image/png"
        return fileType === pattern
      })
    }
  }
}
</script>
